// Maps clean camelCase field keys used in the UI to the legacy WinForms
// control names still used by API`s/pv/calculation.js, estimation.js,
// pvUtils.js, and sqliteApi.js. Those files are intentionally left
// untouched (same reasoning as chinookdt-software never renaming its
// native calc engine) - toLegacy/fromLegacy in fieldTranslation.js use
// this registry to translate right at that boundary.
export const FIELD_REGISTRY = [
  { key: "client", name: "TextBox1" },
  { key: "projectNo", name: "TextBox2" },
  { key: "vessel", name: "TextBox11" },
  { key: "tagNo", name: "TextBox48" },
  { key: "revNo", name: "TextBox10" },
  { key: "designCode", name: "ComboBox24" },
  { key: "editionAddenda", name: "TextBox91" },
  { key: "uStamp", name: "ComboBox2" },
  { key: "crn", name: "TextBox89" },
  { key: "designInternalPressure", name: "txtDPressure" },
  { key: "designExternalPressure", name: "TextBox92" },
  { key: "designTemperature", name: "txtDTemp" },
  { key: "mdmt", name: "TextBox94" },
  { key: "corrosionAllowanceShell", name: "txtVCA" },
  { key: "corrosionAllowanceNozzle", name: "TextBox28" },
  { key: "jointEffLong", name: "TextBox31" },
  { key: "jointEffCirc", name: "TextBox32" },
  { key: "radiography", name: "ComboBox20" },
  { key: "windSpeed", name: "TextBox49" },
  { key: "windDesignCode", name: "TextBox50" },
  { key: "seismicZone", name: "TextBox_Seismic_Spec" },
  { key: "impactTest", name: "ComboBox6" },
  { key: "orientation", name: "ComboBox5" },
  { key: "diameterBasis", name: "ComboBox7" },
  { key: "vesselDiameter", name: "txtVIDia" },
  { key: "vesselLengthTT", name: "txtVLenTT" },
  { key: "vesselLengthSS", name: "txt_SF" },
  { key: "headType", name: "ComboBox3" },
  { key: "supportType", name: "ComboBox1" },
  { key: "hydrotestDesignBasis", name: "ComboBox8" },
  { key: "hydrotestPressure", name: "TextBox67" },
  { key: "liquidHeight", name: "TextBox66" },
  { key: "liquidDensity", name: "TextBox30" },
  { key: "insulationThk", name: "TextBox80" },
  { key: "insulationDensity", name: "TextBox29" },
  { key: "pwht", name: "ComboBox18" },
  { key: "flangeRating", name: "TextBox52" },
  { key: "asmeB165Group", name: "TextBox64" },
  { key: "shellMaterial", name: "ComboBox9" },
  { key: "shellStress", name: "TextBox68" },
  { key: "shellCurve", name: "TextBox88" },
  { key: "headMaterial", name: "ComboBox11" },
  { key: "headStress", name: "TextBox73" },
  { key: "headCurve", name: "TextBox90" },
  { key: "nozzleMaterial", name: "ComboBox12" },
  { key: "nozzleStress", name: "TextBox78" },
  { key: "nozzleCurve", name: "TextBox95" },
  { key: "flangeMaterial", name: "ComboBox13" },
  { key: "flangeStress", name: "TextBox79" },
  { key: "flangeCurve", name: "TextBox96" },
  { key: "rfPadMaterial", name: "ComboBox14" },
  { key: "rfPadStress", name: "TextBox81" },
  { key: "rfPadCurve", name: "TextBox102" },
  { key: "studBoltMaterial", name: "ComboBox15" },
  { key: "studBoltStress", name: "TextBox82" },
  { key: "studBoltCurve", name: "TextBox103" },
  { key: "gasketMaterial", name: "ComboBox16" },
  { key: "gasketStress", name: "TextBox86" },
  { key: "gasketCurve", name: "TextBox104" },
  { key: "shellMaterialReq", name: "ComboBox_ShellReq" },
  { key: "headMaterialReq", name: "ComboBox_HeadReq" },
  { key: "nozzleMaterialReq", name: "ComboBox_NozzleReq" },
  { key: "flangeMaterialReq", name: "ComboBox_FlangeReq" },
  { key: "rfPadMaterialReq", name: "ComboBox_PadReq" },
  { key: "studBoltMaterialReq", name: "ComboBox_StudReq" },
  { key: "gasketMaterialReq", name: "ComboBox_GaskReq" },
  { key: "siUnits", name: "SI_Units_RB" },
  { key: "engUnits", name: "Eng_Units_RB" },
  { key: "cscDoT", name: "TextBox75" },
  { key: "cscLDo", name: "TextBox74" },
  { key: "cscEMAWP", name: "TextBox63" },
  { key: "cscReqThk", name: "TextBox106" },
  { key: "cscMAWP", name: "TextBox85" },
  { key: "cscMAPNC", name: "TextBox107" },
  { key: "cscHydrotestUG99b", name: "TextBox182" },
  { key: "cscHydrotestUG99c", name: "TextBox183" },
  { key: "cscPercentElongation", name: "TextBox184" },
  { key: "cscMDMTNoImpact", name: "TextBox185" },
  { key: "cscDoTSummary", name: "TextBox5" },
  { key: "cscLDOSummary", name: "TextBox4" },
  { key: "cscEMAWPSummary", name: "TextBox24" },
  { key: "externalPressureCSC", name: "TextBox6" },
  { key: "externalPressureEHC", name: "TextBox13" },
  { key: "ehcReqThk", name: "TextBox118" },
  { key: "ehcMAWP", name: "TextBox119" },
  { key: "ehcMAPNC", name: "TextBox120" },
  { key: "ehcHydrotestUG99b", name: "TextBox121" },
  { key: "ehcHydrotestUG99c", name: "TextBox122" },
  { key: "ehcPercentElongation", name: "TextBox123" },
  { key: "ehcMDMTNoImpact", name: "TextBox124" },
  { key: "saddleS1AtSaddle", name: "TextBox143" },
  { key: "saddleS1Midspan", name: "TextBox144" },
  { key: "saddleS2Away", name: "TextBox145" },
  { key: "saddleS2Close", name: "TextBox146" },
  { key: "saddleS3", name: "TextBox147" },
  { key: "saddleS4Unstiffened", name: "TextBox148" },
  { key: "saddleS4SmallL", name: "TextBox149" },
  { key: "saddleS5", name: "TextBox150" },
];

export const legacyMap = Object.fromEntries(
  FIELD_REGISTRY.map((field) => [field.key, field.name]),
);

export const keyMap = Object.fromEntries(
  FIELD_REGISTRY.map((field) => [field.name, field.key]),
);
